import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { reduceResolution, wbp } from 'Theme';

export const useSingleSaleSuccessStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%',
            height: '100%',
            display: 'flex',
            position: 'relative',
            flexDirection: 'column',

            [theme.breakpoints.up('md')]: {
                justifyContent: 'center'
            }
        },

        closeBtn: {
            top: -6,
            right: 0,
            border: 0,
            zIndex: 100,
            fontSize: 20,
            color: '#000000',
            cursor: 'pointer',
            padding: '0px 4px',
            position: 'absolute',
            backgroundColor: 'transparent'
        },

        boxContainer: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            flexDirection: 'column',

            [theme.breakpoints.down('md')]: {
                flex: 1
            }
        },

        typoTittle: {
            textAlign: 'center',
            [theme.breakpoints.down(wbp)]: {
                paddingTop: `${reduceResolution(20)}px`,
                paddingBottom: `${reduceResolution(10)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingTop: '20px',
                paddingBottom: '10px'
            }
        },

        typoMessage: {
            color: '#000',
            fontSize: 16,
            lineHeight: 1.4,
            textOverflow: 'balance',
            textAlign: 'center',
            marginBottom: 24,

            [theme.breakpoints.down('sm')]: {
                maxWidth: 245
            }
        },

        totalPaid: {
            fontSize: 16,
            lineHeight: 1.4,
            fontWeight: 600,

            [theme.breakpoints.up('md')]: {
                fontSize: 18
            }
        },

        icon: {
            fontSize: 82,
            color: '#5E8677'
        },

        title: {
            fontSize: 26,
            lineHeight: 1,
            fontWeight: 600,
            color: '#000000',
            marginTop: 16,
            marginBottom: 8,

            [theme.breakpoints.up('md')]: {
                fontSize: 28
            }
        },

        button: {
            [theme.breakpoints.down('md')]: {
                'height': 55,
                'borderRadius': 30,

                '& span': {
                    fontSize: 18
                }
            },
            [theme.breakpoints.up('md')]: {
                padding: '25px 25px',
                margin: '24px auto 0px'
            }
        }
    })
);
